import type { SupabaseClient } from '@supabase/supabase-js';
import { api } from './api';

/**
 * Le client Supabase Auth, créé à la demande.
 *
 * Son URL et sa clé publique viennent de l'API (`/auth/config`) et non d'une
 * variable de l'image web : un seul endroit à régler par environnement. Le
 * module n'est chargé qu'au moment de se connecter — un utilisateur déjà
 * connecté ne le télécharge jamais.
 *
 * Rend `null` si Supabase n'est pas configuré : l'écran le dit, sans planter
 * (« intégration non configurée »).
 */
let client: SupabaseClient | null | undefined;

interface SupabasePublicConfig {
  url: string | null;
  anonKey: string | null;
}

export async function supabase(): Promise<SupabaseClient | null> {
  if (client !== undefined) return client;
  const cfg = await api.get<SupabasePublicConfig>('/auth/supabase');
  if (!cfg.url || !cfg.anonKey) {
    client = null;
    return client;
  }
  const { createClient } = await import('@supabase/supabase-js');
  client = createClient(cfg.url, cfg.anonKey, {
    auth: {
      // Clé propre à la borne : la Supabase de la VM sert plusieurs applications.
      storageKey: 'sb-borne-technique-auth',
      flowType: 'pkce',
      detectSessionInUrl: true,
      persistSession: true,
    },
  });
  return client;
}
